import type { Supply48DataDay } from '@ebalance/proto/bffuser/v1/supply_48_data_model_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'

import { protoDateToCivilDate } from '~/models/civilDate'
import type { GateCloseFrontier } from '~/models/gateClose'
import { isKomaGateClosed } from '~/models/gateClose'

/**
 * セル単位の編集不可判定: GC ロックに加え、契約の受渡期間の外の日
 * (`outsideDeliveryPeriod`、期間短縮後も据え置かれた確定値の行) は
 * 全コマ読み取り専用とする (supply-48-data.md 対象日選択)。
 *
 * GC ロック (conventions.md「GC（ゲートクローズ）による編集ロック」/
 * supply-48-data.md AC-S4D-011〜013) は一覧取得時の backend の GC 境界
 * (`gate_close_frontier`) との比較だけで決める。過去日・当日・翌日の場合分けと
 * 日跨ぎ (前日 23:00 / 23:30 に翌日のコマ 1 / 2 が GC 済み) は backend が解決済み
 * (`~/models/gateClose`)。境界は取得時点のまま進めない (再取得までは取得時の判定を保つ。
 * 保存時は backend が改めて判定する)。
 *
 * 印は 48 点行がある日にしか付かず、行の無い期間外の日は判別できない。
 *
 * @param gateClose 一覧取得時の GC 境界 (未取得は undefined = GC で縛らない)
 * @param day その列・その日の Supply48DataDay (行が無い日は undefined)
 * @param deliveryDate 行の受渡日 (google.type.Date)
 * @param komaNumber コマ番号 (1-48)
 */
export function isCellLocked(
  gateClose: GateCloseFrontier | undefined,
  day: Supply48DataDay | undefined,
  deliveryDate: ProtoDate | undefined,
  komaNumber: number,
): boolean {
  if (day?.outsideDeliveryPeriod === true) {
    return true
  }
  return isKomaGateClosed(
    gateClose,
    protoDateToCivilDate(deliveryDate),
    komaNumber,
  )
}
